import firebase from "firebase/compat/app"
import "firebase/compat/firestore"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: "AIzaSyCUmMTSTwqHkLXpqaPFbMVvbGGLMxX_pZI",
  authDomain: "zonghao-portfolio.firebaseapp.com",
  projectId: "zonghao-portfolio",
  storageBucket: "zonghao-portfolio.appspot.com",
  messagingSenderId: "64466346984",
  appId: "1:64466346984:web:ebf0479244b6a69f843a5d",
  measurementId: "G-0W20HJ22P4"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

export const firestore = firebase.firestore()
